import { faHandshake } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import "../../../style";





class FeatureThree extends Component {
    render(){
        return(
            <Grid item sm={3} xs={12}>
                <div className="featureCard">
                    <div className="featureIcon">
                        <FontAwesomeIcon icon={faHandshake} className="featureSvg"/>
                    </div>
                    <h3 className="CardHead">Reconcile Records</h3>
                    <p className="cardDescription">
                    Reconcile your inputs
with counterparty
records                    </p>
            </div>
            </Grid>
        );
    }
}

export default FeatureThree;


// WEBPACK FOOTER //
// ./src/components/public/Home/FeatureThree.js